export default __webpack_public_path__ + "static/media/profile-home-2.0ae6c012.jpg";